import { Controller } from "@hotwired/stimulus"

// 플랫폼 채팅 상단 계정 안내 띠.
// 한 줄이라 잘리는 텍스트를 hover 시 느리게 가로 스크롤(마퀴)해 잘린 부분을 드러낸다.
export default class extends Controller {
  static targets = ["viewport", "text"]

  connect() {
    this.boundMeasure = this.measure.bind(this)
    window.addEventListener("resize", this.boundMeasure)
    this.measure()
  }

  disconnect() {
    window.removeEventListener("resize", this.boundMeasure)
  }

  // 잘린 정도(overflow px) 측정
  measure() {
    if (!this.hasTextTarget || !this.hasViewportTarget) return
    this.overflow = Math.max(0, this.textTarget.scrollWidth - this.viewportTarget.clientWidth)
  }

  enter() {
    this.measure()
    if (!this.overflow || this.overflow <= 1) return // 안 잘리면 아무것도 안 함

    // 잘린 텍스트 느리게 노출 (마퀴). 40px/s 정도, 2~8초로 클램프
    const seconds = Math.min(8, Math.max(2, this.overflow / 40))
    this.textTarget.style.transition = `transform ${seconds}s linear`
    this.textTarget.style.transform = `translateX(-${this.overflow}px)`
  }

  leave() {
    if (!this.hasTextTarget) return
    this.textTarget.style.transition = "transform .4s ease"
    this.textTarget.style.transform = "translateX(0)"
  }
}
